import { useViewerStore } from '../store/store';

/**
 * Unblocks the dashboard gate, opens the dashboard, and shows a banner with the load failure message.
 * Used instead of a blocking modal so users can still use dashboard actions where appropriate.
 */
export function reportSiteLoadErrorForDashboard(message: string): void {
    useViewerStore.setState({
        loadingCompleted: true,
        refreshingShade: false,
        siteLoadingError: message,
        isDashboardOpen: true,
    });
}
